<!--
 * @Author: Tina Huang
 * @Date: 2023-11-10 14:53:41
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-17 09:45:49
 * @Description: 
-->
<template>
  <div class="box">
    <el-radio-group v-model="type" style="width: 100%">
      <el-radio-button label="notion">Notion</el-radio-button>
      <el-radio-button label="flowus">FlowUs</el-radio-button>
    </el-radio-group>
    <br /><br />
    <template v-if="type === 'flowus'">
      <el-input v-model="name" placeholder="请输入模板内容"></el-input
      ><br /><br />
      <el-input v-model="link" placeholder="请输入链接"></el-input><br /><br />
      <el-date-picker
        v-model="expired_date"
        type="date"
        placeholder="选择到期日期"
        style="width: 100%"
      >
      </el-date-picker
      ><br /><br />
      <div class="list" v-if="type === 'flowus'">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>常用模板链接</span>
          </div>
          <div v-for="o in lists" :key="o.name" class="text item">
            <el-button
              type="success"
              round
              style="margin-top: 0; margin-bottom: 10px"
              @click.stop="handleQuickLink(o)"
              >{{ o.name }}</el-button
            >
          </div>
        </el-card>
      </div>
    </template>
    <template v-else>
      <el-input v-model="link" placeholder="请输入链接"></el-input><br /><br />
      <el-input v-model="code" placeholder="请输入口令"></el-input><br /><br />
      <el-input v-model="days" placeholder="请输入天数"></el-input><br /><br />
    </template>
    <el-button
      type="primary"
      round
      size="large"
      style="width: 100%"
      v-clipboard:copy="result"
      v-clipboard:success="handleCopy"
      >创建链接</el-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      link: "",
      domain:
        "https://httishere.github.io/notion-widget/temps/flowus-share.html",
      notion_domain: "#/mpicks/get",
      expired_date: null,
      name: "",
      type: "notion",
      lists: [
        {
          name: "2024 FlowUs总链接",
          link: "https://flowus.cn/httishere/share/42350960-07c0-4ef6-82fa-6a077227f0d0?promotionChannel=Red_fwj_43",
        },
        {
          name: "2023 FlowUs 年度相关",
          link: "https://flowus.cn/httishere/share/2aaa42b8-aea8-4b68-b426-ba0e313e1999?promotionChannel=Red_fwj_42",
        },
        {
          name: "2023 FlowUs 常用模板",
          link: "https://flowus.cn/share/252d38ec-6ee2-426d-8ab8-5add133abb62?promotionChannel=Red_fwj_23",
        },
      ],
      code: "",
      days: 2, // 过期时长
    };
  },
  computed: {
    result() {
      if (!this.link) return null;
      if (this.type === "flowus") {
        const tip =
          "将链接复制到手机/电脑浏览器后打开，点击右上角三个点【拷贝到】即可放到自己的空间啦～";
        const msg = this.handleReadLink(this.link);
        let encrypted = this.$crypto.aseEncryptParams(JSON.stringify(msg));
        return `${this.name ? this.name + "：\n\n" : ""}${
          this.domain
        }?e=${encrypted}\n\n${tip}\n\n❗️ 请及时拷贝模板避免过期`;
      } else if (this.type === "notion") {
        console.log(this.link);
        const __links = this.link.split("/");
        const link_id = window.btoa(__links[__links.length - 1]);

        const tip =
          "✅ 模板拷贝方法：复制模版链接在浏览器打开，点击右上角「duplicate」拷贝到自己空间\n\n ❗️ 请及时拷贝模板避免过期";
        const __p = window.btoa(
          link_id +
            "-" +
            this.code +
            "-" +
            (new Date().getTime() + this.days * 864000000).toString()
        );
        const _href = window.location;
        return `${_href.origin}${_href.pathname}${this.notion_domain}/${__p}\n\n${tip}`;
      }
      return null;
    },
  },
  methods: {
    handleCopy() {
      this.$message({
        message: "创建成功",
        type: "success",
      });
    },
    handleReadLink(link) {
      if (link.includes("flowus")) {
        const res = link.split("share/");
        const msg = res[1].split("?");
        const versions = msg[1].split("fwj_");
        return {
          share: msg[0],
          version: versions[1],
          dd: this.expired_date ? this.expired_date.toLocaleString() : "",
          name: this.name,
        };
      }
    },
    handleQuickLink(o) {
      this.link = o.link;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  margin: 30px auto;
  text-align: center;
  padding: 0 24px;
  button {
    margin-top: 50px;
  }
}
</style>